module.exports = __webpack_public_path__ + "img/headportrait_8_icon.01b170f7.png";